import bone from "./specialities/bone.png";
import ent from "./specialities/ent.png";
import heart from "./specialities/heart.png";
import illness from "./specialities/illness.png";
import surgery from "./specialities/surgery.png";
import tooth from "./specialities/tooth.png";

export const specializationAssets = [
  {
    specialization_name: "Cardiologist",
    specialization_image: bone,
  },
  {
    specialization_name: "Dermatologist",
    specialization_image: ent,
  },
  {
    specialization_name: "Orthopedic Surgeon",
    specialization_image: heart,
  },
  {
    specialization_name: "Gynecologist",
    specialization_image: illness,
  },
  {
    specialization_name: "Neurologist",
    specialization_image: surgery,
  },
  {
    specialization_name: "Ophthalmologist",
    specialization_image: tooth,
  },
  {
    specialization_name: "Bone",
    specialization_image: bone,
  },
  {
    specialization_name: "ENT",
    specialization_image: ent,
  },
  {
    specialization_name: "Heart",
    specialization_image: heart,
  },
  {
    specialization_name: "Illness",
    specialization_image: illness,
  },
  {
    specialization_name: "Surgery",
    specialization_image: surgery,
  },
  {
    specialization_name: "Tooth",
    specialization_image: tooth,
  },
];
